module.exports = __webpack_public_path__ + "static/media/wetton-logo.eae956af.jpeg";